module.exports = __webpack_public_path__ + "media/content-creator/mobile-health-2-fae09659.png";